import { IS_A_FUNCTION, IS_NOT_EMPTY, IS_SET } from '@core/util/check.util'

export const TO_STRING = (_: any): string => {
  let res = ''
  if (IS_SET(_) && !Number.isNaN(_)) {
    if ((typeof _ === 'string')) {
      res = _
    } else if (IS_A_FUNCTION((_).toString)) {
      res = (_).toString()
    } else if (IS_NOT_EMPTY(_)) {
      res = JSON.stringify(_)
    }
  }
  return res
}

export const STRING_LCF = (input: string): string => `${(input[0] ?? '').toLowerCase()}${input.substring(1)}`
export const STRING_UCF = (input: string): string => `${(input[0] ?? '').toUpperCase()}${input.substring(1)}`

// Unicode Character 'ZERO WIDTH SPACE' (U+200B)
export const ZWSP = '​'
